// extracted by mini-css-extract-plugin
export default {"circle":"UserIcon_circle__P7JRF","user":"UserIcon_user__j+xfq"};